export default __webpack_public_path__ + "static/media/close.e9223aa2.svg";